import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

// 获取订单信息
export const getOrderList = async (params: object) => {
  return await GET({
    url: Api.getOrderList,
    params: {
      ...params
    },
    showError: false
  })
}

// 有关订单的系统类配置
export const orderConfig = async (params: object) => {
  return await GET({
    url: Api.orderConfig,
    params: {
      ...params
    },
    showError: false
  })
}
